export default {
  leaflet:
    'pk.eyJ1IjoiY2FycG8tYWkiLCJhIjoiY2tvcjAyeTZzMGhiZzJ3cGRmajRjY3NvYSJ9.oFg4_QSrJKefSv7o7HrrdA',
  api: 'https://core.carpo.tech/api/v1/',
  api2: 'https://core.carpo.tech/api/v2/',
  api3: 'https://core.carpo.tech/api/v3/',
  oldtile: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  tile: 'https://carpo.tap30.services/styles/services_v1.0/{z}/{x}/{y}.png',
}
